import React from 'react';

import {
  Box,
  Button,
  Grid,
  styled
} from '@mui/material';
import {
  fields,
  Form,
  formUtil,
  validationUtil
} from 'iron-forge-react-modules';
import {
  BaseWidget,
  selectFields
} from 'modules/layer01';

import { appFormUtil } from 'modules/layer00';
import { useForm } from 'react-hook-form';
import * as dataService from './dataService';
import * as types from './types';



const ControlledTextField = fields.TextField.genControllerComponent<types.IFormState>();
const {
  genController: genControlledSalesChannelSelectField
} = selectFields.SalesChannelSelectField.genComponentAndControllerGenerator();
const ControlledSalesChannelSelectField = genControlledSalesChannelSelectField<types.IFormState>();
const {
  genController: genControlledNetSuiteLocationSelectField
} = selectFields.NetSuiteLocationSelectField.genComponentAndControllerGenerator();
const ControlledNetSuiteLocationSelectField = genControlledNetSuiteLocationSelectField<types.IFormState>();
const {
  genController: genControlledNetSuiteSubsidiarySelectField
} = selectFields.NetSuiteSubsidiarySelectField.genComponentAndControllerGenerator();
const ControlledNetSuiteSubsidiarySelectField = genControlledNetSuiteSubsidiarySelectField<types.IFormState>();
const {
  genController: genControlledNetSuiteDepartmentSelectField
} = selectFields.NetSuiteDepartmentSelectField.genComponentAndControllerGenerator();
const ControlledNetSuiteDepartmentSelectField = genControlledNetSuiteDepartmentSelectField<types.IFormState>();
const {
  genController: genControlledNetSuiteTaxItemSelectField
} = selectFields.NetSuiteTaxItemSelectField.genComponentAndControllerGenerator();
const ControlledNetSuiteTaxItemSelectField = genControlledNetSuiteTaxItemSelectField<types.IFormState>();
const {
  genController: genControlledNetSuiteEmployeeSelectField
} = selectFields.NetSuiteEmployeesSelectField.genComponentAndControllerGenerator();
const ControlledNetSuiteEmployeeSelectField = genControlledNetSuiteEmployeeSelectField<types.IFormState>();
const {
  genController: genControlledNetSuiteBrandSelectField
} = selectFields.NetSuiteBrandSelectField.genComponentAndControllerGenerator();
const ControlledNetSuiteBrandSelectField = genControlledNetSuiteBrandSelectField<types.IFormState>();



const FormContentBox = styled(Box)(({ theme }) => ({
  padding: theme.spacing(1)
}));



export interface IProps {
  storeId: string;
}

export const FC: React.FC<IProps> = props => {
  const queryTuple = dataService.useQuery(props.storeId);
  const [saveNetSuiteSettings, saveNetSuiteSettingsTuple] = dataService.useSaveNetSuiteSettings(props.storeId);
  const form = useForm<types.IFormState>({
    defaultValues: {
      packingSlipInformation: '',
      netSuiteClientInternalId: ''
    }
  });
  formUtil.useSetFormFields(queryTuple, form.setValue, [
    'salesChannel',
    'netSuiteLocation',
    'netSuiteSubsidiary',
    'netSuiteDepartment',
    'netSuiteTaxItem',
    'packingSlipInformation',
    'netSuiteClientInternalId',
    'netSuiteEmployee',
    'netSuiteBrand'
  ]);



  function processSubmit(formState: types.IFormState) {
    saveNetSuiteSettings(appFormUtil.trimFormStateValues(formState));
  }



  const loading = queryTuple.loading || saveNetSuiteSettingsTuple.loading;

  return (
    <Form.FC
      disableDefaultOverflow
      onSubmit={form.handleSubmit(processSubmit)}>
      <BaseWidget.FC title="NetSuite"
        elAction={(
          <Button
            variant="contained"
            disabled={loading}
            type="submit">
            Save
          </Button>
        )}>
        <FormContentBox>
          <Grid
            container
            spacing={1}>
            <Grid
              item
              xs={12}
              md={6}>
              <ControlledNetSuiteSubsidiarySelectField
                isDisabled={loading}
                label="Subsidiary"
                fieldKey="netSuiteSubsidiary"
                formControl={form.control} />
            </Grid>

            <Grid
              item
              xs={12}
              md={6}>
              <ControlledNetSuiteBrandSelectField
                isDisabled={loading}
                label="Brand"
                fieldKey="netSuiteBrand"
                formControl={form.control} />
            </Grid>

            <Grid
              item
              xs={12}
              md={6}>
              <ControlledNetSuiteLocationSelectField
                isDisabled={loading}
                label="Location"
                fieldKey="netSuiteLocation"
                formControl={form.control} />
            </Grid>

            <Grid
              item
              xs={12}
              md={6}>
              <ControlledNetSuiteDepartmentSelectField
                isDisabled={loading}
                label="Department"
                fieldKey="netSuiteDepartment"
                formControl={form.control} />
            </Grid>

            <Grid
              item
              xs={12}
              md={6}>
              <ControlledSalesChannelSelectField
                isDisabled={loading}
                label="Sales Channel"
                fieldKey="salesChannel"
                formControl={form.control} />
            </Grid>

            <Grid item
              xs={12}
              md={6}>
              <ControlledTextField
                isDisabled={loading}
                isRequired={queryTuple.data.isTier1}
                extraValidationRules={{ pattern: validationUtil.reDecimalNumber }}
                label="NS Client Internal ID"
                fieldKey="netSuiteClientInternalId"
                formControl={form.control} />
            </Grid>

            <Grid
              item
              xs={12}
              md={6}>
              <ControlledNetSuiteTaxItemSelectField
                isDisabled={loading}
                label="Tax Item"
                fieldKey="netSuiteTaxItem"
                formControl={form.control} />
            </Grid>

            <Grid
              item
              xs={12}
              md={12}>
              <ControlledTextField
                numLines={5}
                isDisabled={loading}
                label="Packing Slip Information"
                fieldKey="packingSlipInformation"
                formControl={form.control} />
            </Grid>

            <Grid
              item
              xs={12}
              md={12}>
              <ControlledTextField
                numLines={5}
                isDisabled={loading}
                label="Packing Slip Information"
                fieldKey="packingSlipInformation"
                formControl={form.control} />
            </Grid>

            <Grid
              item
              xs={12}
              md={12}>
              <ControlledNetSuiteEmployeeSelectField
                isDisabled={loading}
                label=""
                fieldKey="netSuiteEmployee"
                formControl={form.control} />
            </Grid>
          </Grid>
        </FormContentBox>
      </BaseWidget.FC>
    </Form.FC>
  );
};
